import { bg, cs, da, deAT, de, enAU, enCA, enGB, enIE, enUS, es, fr, frCA, hu, id, it, nl, nlBE, pl, pt, ptBR, ro, ru, sr, sv, th, tr, uk } from 'date-fns/locale';

export default { bg, cs, da, deAT, de, enAU, enCA, enGB, enIE, enUS, es, fr, frCA, hu, id, it, nl, nlBE, pl, pt, ptBR, ro, ru, sr, sv, th, tr, uk };
